import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Clock, Dumbbell, Home, User, Video } from 'lucide-react';

/**
 * Fixed bottom nav with five tabs: Home, Analysis, History, Training, Account.
 */
export function BottomNav() {
  const { pathname } = useLocation();

  const homeActive = pathname.startsWith('/dashboard');
  const isSessionProcessing = /^\/sessions\/\d+\/?$/.test(pathname);
  const analysisActive =
    pathname.startsWith('/upload') ||
    pathname.includes('/analysis') ||
    pathname.includes('/takeaways') ||
    pathname.includes('/strengths') ||
    isSessionProcessing;
  const historyActive = pathname.startsWith('/history');
  const trainingActive = pathname.startsWith('/training');
  const accountActive = pathname.startsWith('/account');

  const TabInner = ({ active, children }) => (
    <span
      className={`rounded-xl px-5 py-2 flex flex-col items-center ${
        active ? 'bg-beachvision-cta' : ''
      }`}
    >
      {children}
    </span>
  );

  const iconClass = (active) =>
    `h-5 w-5 ${active ? 'text-beachvision-on-coral' : 'text-beachvision-muted'}`;

  const labelClass = (active) =>
    `mt-1 font-display text-xs font-bold uppercase tracking-wide ${
      active ? 'text-white' : 'text-beachvision-muted'
    }`;

  const tabs = [
    { to: '/dashboard/', active: homeActive, icon: Home, label: 'Home' },
    { to: '/upload/', active: analysisActive, icon: Video, label: 'Analysis' },
    { to: '/history/', active: historyActive, icon: Clock, label: 'History' },
    { to: '/training/', active: trainingActive, icon: Dumbbell, label: 'Training' },
    { to: '/account/', active: accountActive, icon: User, label: 'Account' },
  ];

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 bg-beachvision-bg pb-6 pt-2"
      aria-label="Main navigation"
    >
      <div className="max-w-beachvision-shell mx-auto flex">
        {tabs.map(({ to, active, icon: Icon, label }) => (
          <Link
            key={to}
            to={to}
            className="flex flex-1 flex-col items-center justify-center py-1"
          >
            <TabInner active={active}>
              <Icon
                className={iconClass(active)}
                strokeWidth={active ? 2.5 : 2}
              />
            </TabInner>
            <span className={labelClass(active)}>{label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
}
